import React, { FC } from 'react';

import { Collapse, TableCell, TableRow } from '@material-ui/core';

import { useAssignResultsState } from '../../../../../../../../Common/AssignResults/Context/AssignResults.context';
import { ISkinsTableRow } from '../SkinsTableRow';

interface IProps extends ISkinsTableRow {
  collapsedRow: null | number;
}

const SkinsTableTiedExpandedRow: FC<IProps> = props => {
  const { hole, index, collapsedRow } = props;
  const { selectedCombination, skinsResults } = useAssignResultsState();

  return selectedCombination ? (
    <TableRow
      className="results-table-table-body-row-expandable expandable-row"
      key={`hiddenTableRow-${index}`}
    >
      <TableCell />

      <TableCell
        className="inner-cell"
        colSpan={3}
        classes={{ root: 'leaderboard-row-event-summary' }}
      >
        <Collapse
          className={`collapse-${index}`}
          classes={{
            container: 'leaderboard-collapse',
            wrapperInner: 'leaderboard-collapse__wrapper-inner override'
          }}
          in={collapsedRow === index}
          timeout="auto"
          unmountOnExit={true}
        >
          {skinsResults[Number(hole)].map((player: any, expandedIndex: number) => (
            <div className="eliminated-player-row" key={`collapse-item-${expandedIndex}`}>
              {`${player.userFirstName[0]}. ${player.userLastName}`}
            </div>
          ))}
        </Collapse>
      </TableCell>
    </TableRow>
  ) : (
    <></>
  );
};

export default SkinsTableTiedExpandedRow;
